import React from "react";

// Photorealistic image with soft, degraded (feathered) edges that blend into the
// surrounding background — used for premium promotional visuals on the landing page.
export const FadeImage = ({ src, alt = "", className = "", ratio = "56.25%", fade = "all", rounded = "1.25rem" }) => {
  const masks = {
    all: "radial-gradient(120% 120% at 50% 45%, #000 55%, rgba(0,0,0,0) 92%)",
    bottom: "linear-gradient(to bottom, #000 60%, rgba(0,0,0,0) 100%)",
    sides: "linear-gradient(to right, rgba(0,0,0,0) 0%, #000 12%, #000 88%, rgba(0,0,0,0) 100%)",
  };
  const mask = masks[fade] || masks.all;
  return (
    <div className={`relative overflow-hidden ${className}`} style={{ borderRadius: rounded }}>
      <div style={{ paddingTop: ratio }} />
      <img
        src={src}
        alt={alt}
        loading="lazy"
        onError={(e) => { e.currentTarget.style.display = "none"; }}
        className="absolute inset-0 h-full w-full object-cover"
        style={{ WebkitMaskImage: mask, maskImage: mask }}
      />
    </div>
  );
};
